import { get, init } from "./schedule.js";
function delayFunction(id, value) {
    return function () {
        init(this, id).delay = +value.apply(this, arguments);
    };
}
function delayConstant(id, value) {
    return value = +value, function () {
        init(this, id).delay = value;
    };
}
export default function (value) {
    var id = this._id;
    return arguments.length
        ? this.each((typeof value === "function"
            ? delayFunction
            : delayConstant)(id, value))
        : get(this.node(), id).delay;
}
